import { UnaryFunction, Observable } from 'rxjs';
import { debounceTime, buffer } from 'rxjs/operators';

export const debounceBufferTime =
  <T>(timeout: number = 0): UnaryFunction<Observable<T>, Observable<T[]>> =>
  s =>
    buffer<T>(debounceTime(0)(s))(s);
